"use client";

import { Box, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import type { ReactNode } from "react";

type AiOverviewProps = {
  toggleId: string;
  children: ReactNode;
};

export default function AiOverview({ toggleId, children }: AiOverviewProps) {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const toggleRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const toggle = toggleRef.current;
    const content = contentRef.current;
    if (!toggle || !content) return;

    const handleChange = () => {
      if (toggle.checked) return;
      // When collapsing, reset scroll so the preview shows from the top.
      globalThis.requestAnimationFrame(() => {
        content.scrollTop = 0;
      });
    };

    toggle.addEventListener("change", handleChange);
    return () => toggle.removeEventListener("change", handleChange);
  }, []);

  return (
    <Box
      sx={{
        border: "0.85px solid #3636364D",
        background: "#161616",
        borderRadius: 1,
        p: 3,
        mt: 4,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "#fff",
          fontWeight: 600,
          mb: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <img
          src="https://sr-cdn-1.shiprocket.in/sr-promise/images/llm_overview_trends.svg"
          alt="AI Overview Icon"
        />
        AI Overview
      </Typography>
      <div className="ai-overview">
        <input
          id={toggleId}
          className="ai-overview__toggle"
          type="checkbox"
          ref={toggleRef}
        />
        <div ref={contentRef} className="ai-overview__content">
          {children}
        </div>
        <div className="ai-overview__fade" aria-hidden="true" />
        <label htmlFor={toggleId} className="ai-overview__button">
          <span className="ai-overview__more">Read full summary</span>
          <span className="ai-overview__less">Show less</span>
        </label>
      </div>
    </Box>
  );
}
